<template>
  <div class="person_cp_table_holder">
    <table class="person_cp_table">
      <thead>
        <tr><th>LOCATION </th><th>DIST.</th><th>PACE</th><th>TIME</th></tr>
      </thead>
      <tbody id="athletecps">
        <tr v-for="cp in checkpointsOrder">
          <td>{{cp.name}}</td>
          <td>{{cpdistance(cp)}}</td>
          <td>{{pace(cp)}}</td>
          <td>{{cptime(cp)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style>

</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      checkpoints: 'checkpoints',
      athlete: 'athlete'
    }),
    checkpointsOrder () {
      let arr = []
      for(let key in this.checkpoints) {
        arr.push(this.checkpoints[key])
      }
      return arr.sort(function(a,b) {if (
        a.order < b.order)
        return -1;
        if (a.order > b.order)
          return 1;
        return 0;})
    }
  },
  methods: {
    pace: function (cp) {
      if (typeof (this.athlete.checkpoints) !== 'undefined') {
        let checkpoint = this.athlete.checkpoints.filter(function(checkpoint) {
          return checkpoint.id === cp.id
        })[0];
        if (checkpoint && checkpoint.distance > 0.0) {
          return (checkpoint.distance / checkpoint.duration * 3.6).toFixed(1) + ' km/h'
        } else {
          return ''
        }
      }
    },
    cptime: function (cp) {
      if (typeof (this.athlete.checkpoints) !== 'undefined') {
        let checkpoint = this.athlete.checkpoints.filter(function(checkpoint) {
          return checkpoint.id === cp.id
        })[0];
        if (checkpoint) {
          return this.toHHMMSS(checkpoint.duration)
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    cpdistance: function (cp) {
      return (cp.point.distance / 1000.0).toFixed(1) + ' km'
    },
    toHHMMSS: function (secs) {
      var secNum = parseInt(secs, 10) // don't forget the second param
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)
      if ((minutes < 10)) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      if (hours < 10) {
        hours = '' + hours
      }
      var time
      if (hours === '0') {
        time = '0:' + minutes // + seconds
      } else {
        time = hours + ':' + minutes // + ':' + seconds
      }
      return time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/athlete/athletecptablevue.vue